enum EPlataforma {
  Android = 'Android (Nativo)',
  iOS = 'iOS (Nativo)',
  Desktop = 'Desktop (Nativo)',
  NavegadorAndroid = 'Navegador (Android)',
  NavegadoriOS = 'Navegador (iOS)',
  NavegadorDesktop = 'Navegador (Desktop)',
  TekServer = 'TekServer',
  Desconhecido = 'Desconhecido',
}

export function obterIconeAssociadoPlataforma(pPlataforma: EPlataforma) {
  switch (pPlataforma) {
    case EPlataforma.Android:
      return 'mdi-android';
    case EPlataforma.iOS:
      return 'mdi-apple';
    case EPlataforma.Desktop:
      return 'mdi-web';
    case EPlataforma.NavegadorAndroid:
      return 'mdi-web-box';
    case EPlataforma.NavegadoriOS:
      return 'mdi-apple-safari';
    case EPlataforma.NavegadorDesktop:
      return 'mdi-web';
    case EPlataforma.TekServer:
      return 'mdi-server';
    default:
      return 'mdi-help-circle-outline';
  }
}

export function obterCorAssociadoPlataforma(pPlataforma: EPlataforma) {
  switch (pPlataforma) {
    case EPlataforma.Android:
      return 'green-darken-1';
    case EPlataforma.iOS:
      return 'grey-darken-3';
    case EPlataforma.NavegadorAndroid:
    case EPlataforma.NavegadorDesktop:
    case EPlataforma.NavegadoriOS:
      return 'blue-lighten-1';
    case EPlataforma.Desktop:
      return 'indigo';
    case EPlataforma.TekServer:
      return 'grey-lighten-1';

    default:
      return 'error';
  }
}

export default EPlataforma;
